<script lang="ts">
	import { Route, Router } from 'svelte-routing'

	export let url
	import Login from './Pages/Login.svelte';
	import Signup from './Pages/Signup.svelte';
	import Home from './Pages/Home.svelte';
	import Withdrawal from './Pages/Withdrawal.svelte';
	import CryptoWithdrawal from './Pages/Crypto.svelte';
</script>

<Router url="{url}">
	<div class="bg-gray-100">
    <Route path="/">
			<Signup />
		</Route>
		<Route path="/login">
			<Login />
		</Route>
		<Route path="/home" component={Home} />
		<Route path="/withdraw" component={Withdrawal} />
		<Route path='/crypto' component={CryptoWithdrawal} />
  </div>
</Router>